import i18n from "../../../../../i18n";
import { createLoading } from "../../../../../utils/loading";
import { createPage, createManageDelete, createManageExportCsv, createRowActionView, createRowActionEdit } from "../../../../../utils/page";
import { onClickDeleteAllClient } from "../../../../../utils/form";
import { has } from "../../../../../utils/menu-context";
import { openModalForm as openModalFormMenuSide } from "./menu-side.logic";
import { createColumns as createColumnsMenuSide } from "./menu-side.section";
import { createButtonCreate } from "../../../../../utils/button";
import store from "../../../../../store";
import lodash from "lodash";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/security/menuSide";
export const routerPrefix = "menu-sides";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createColumns = ({ props }) => {
    const { visibleParent } = props;
    const columns = createColumnsMenuSide();
    if (!visibleParent) {
        lodash.remove(columns, d => d.dataIndex?.includes("refParent"));
    }
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items, options: { sort: [{ name: "seq", type: "ASC" }] } });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : has({ menuContext, key: "canDelete" })),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            }
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [];
    data.rowActions = [];
    if (!viewOnly) {
        data.manageExtras.push({
            render: () => ({
                ...createButtonCreate({
                    onClick: () => openModalFormMenuSide({ props: { menuContext, viewOnly, setAppPageHeader: false, form: {} }, items }),
                    options: { text: i18n.global.t("model.menuSide.children") }
                })
            }),
            visible: () => has({ menuContext, key: "canCreate" })
        });

        data.rowActions.push(
            createRowActionEdit({
                menuContext,
                onClick: ({ record }) => openModalFormMenuSide({ props: { menuContext, viewOnly, setAppPageHeader: false, form: record } })
            })
        );
    } else {
        data.rowActions.push(
            createRowActionView({
                menuContext,
                onClick: ({ record }) => openModalFormMenuSide({ props: { menuContext, viewOnly, setAppPageHeader: false, form: record } })
            })
        );
    }

    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
